<div
    class="p-0 mw-1400 m-auto"
    [ngClass]="{
        'p-md-7 gtmpage-search': !isAddonView,
        'pt-md-2 px-md-8 pb-md-8 gtmpage-add-on-search': isAddonView,
    }"
>
    <div class="row-auto g-0 me-md-n4 ms-md-n4">
        <div class="p-0 p-md-1 col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
            <!--            <app-alert-bar *ngIf="isAddonView"></app-alert-bar>-->
            <div class="m-6 m-md-0" id="inputWrapper">
                <app-search-input></app-search-input>
            </div>
        </div>
    </div>
    <div class="row-auto g-0 me-md-n4 ms-md-n4">
        <div class="p-0 p-md-1 col-xs-12 col-sm-12 col-md-4 col-lg-4 col-xl-3">
            <div id="facetsWrapper">
                <div class="facet-wrapper">
                    <app-facets></app-facets>
                </div>
            </div>
        </div>
        <div class="p-0 p-md-1 col-xs-12 col-sm-12 col-md-8 col-lg-8 col-xl-9">
            <div id="resultsWrapper">
                <app-search-results-group></app-search-results-group>
            </div>
        </div>
    </div>
</div>
<app-available-features></app-available-features>
